// extracted by mini-css-extract-plugin
module.exports = {"root":"blog-page_root__5uJJQ","content":"blog-page_content__Kw42V","pagination":"blog-page_pagination__GPOYP"};